<template>
  <div>
    <div class="md-layout md-gutter">
      <div
        v-if="canEquipamentoEditar()"
        class="md-layout-item md-small-size-100 md-size-25"
      >
        <div class="md-layout md-gutter align-items-center">
          <div class="md-layout-item">
            <span class="md-title">{{ equipamentoConfigName }}</span>
          </div>

          <div class="md-layout-item">
            <div style="text-align: right">
              <md-button class="md-icon-button md-raised md-primary">
                <md-icon>settings</md-icon>
              </md-button>
            </div>
          </div>
        </div>
        <hr />

        <FormConfiguracaoEquipamento
          :equipamento="equipamento"
          @update="$emit('change')"
        />
      </div>

      <div class="md-layout-item">
        <template v-if="canCmdAuto()">
          <div class="md-layout md-gutter align-items-center">
            <div class="md-layout-item">
              <span class="md-title">Geral</span>
            </div>

            <div class="md-layout-item">
              <md-button class="md-icon-button" style="visibility: hidden" />
            </div>
          </div>
          <hr />
          <AcompanhamentoConfiguracaoGeral
            :config="equipamento.config"
            :equipamento-id="equipamento.id"
          />
          <hr />
        </template>
        <template v-if="canCalibracao()">
          <div class="md-layout md-gutter align-items-center">
            <div class="md-layout-item">
              <span class="md-title">Sensores</span>
            </div>

            <div class="md-layout-item">
              <md-button
                :disabled="!calibracaoId"
                class="md-raised md-accent"
                @click="() => (shouldShowCancelCalibracaoDialog = true)"
              >
                Cancelar Calibração
              </md-button>
              <md-button
                class="md-raised md-primary"
                @click="dialogEnviarTodos = true"
              >
                Enviar todos
              </md-button>
              <md-tooltip md-direction="left">
                Irá enviar todas as calibrações para o equipamento
              </md-tooltip>
            </div>
          </div>
          <br />
          <AcompanhamentoConfiguracaoSensor
            :key="sensorKey"
            :sensores="sensoresDeCalibracao"
            @enviar="handleEnviarSensor"
          />
        </template>
      </div>
    </div>
    <md-dialog-confirm
      :md-active.sync="dialogEnviarTodos"
      md-content="O sistema irá enviar todas as calibrações para o equipamento. Deseja continuar?"
      md-confirm-text="Enviar"
      md-cancel-text="Cancelar"
      @md-confirm="handleEnvioTodasCalibracoes"
      @md-cancel="dialogEnviarTodos = false"
    />

    <md-dialog-confirm
      :md-active.sync="dialogEnviarSensor"
      md-content="O sistema irá enviar a calibração para o equipamento. Deseja continuar?"
      md-confirm-text="Enviar"
      md-cancel-text="Cancelar"
      @md-confirm="handleEnvioSensorCalibracao"
      @md-cancel="dialogEnviarSensor = false"
    />
    <md-dialog-confirm
      :md-active.sync="shouldShowCancelCalibracaoDialog"
      md-title="Tem certeza?"
      md-content="Cancelar uma calibracção pode não funcionar caso o equipamento já tenha lido o comando"
      md-confirm-text="enviar"
      md-cancel-text="cancelar"
      @md-confirm="cancelCalibracao()"
    />

    <md-dialog :md-active.sync="loading">
      <div class="p-5" style="text-align: center">
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          md-mode="indeterminate"
        />
      </div>
    </md-dialog>
  </div>
</template>

<script>
import AcompanhamentoConfiguracaoGeral from '@/components/equipamento/AcompanhamentoConfiguracaoGeral.vue'
import AcompanhamentoConfiguracaoSensor from '@/components/equipamento/AcompanhamentoConfiguracaoSensor.vue'
import FormConfiguracaoEquipamento from '@/components/equipamento/GerenciarConfiguracaoEquipamento.vue'
import auth from '@/utils/auth'
import { AcaoStatusTipo, EquipamentoConfigTipo } from '@/utils/constants'
import http from '@/utils/http'

export default {
  name: 'EquipamentoCalibracao',
  components: {
    AcompanhamentoConfiguracaoGeral,
    AcompanhamentoConfiguracaoSensor,
    FormConfiguracaoEquipamento,
  },

  props: {
    localId: {
      type: String,
      default: '',
    },
    equipamento: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      sensorKey: 0,
      loadingConfig: true,
      historicoConfig: [],
      dialogEnviarTodos: false,
      sensorEnvioId: null,
      dialogEnviarSensor: false,
      shouldShowCancelCalibracaoDialog: false,
      calibracaoId: null,
    }
  },
  computed: {
    equipamentoConfigName() {
      return (
        EquipamentoConfigTipo[this.equipamento?.equipamentoConfigTipo] ||
        'Carregando...'
      )
    },
    sensoresDeCalibracao() {
      return this.equipamento.sensores.filter((s) => s.calibravel)
    },
  },
  watch: {
    equipamento() {
      const shouldClearCalibracaoId = !this.equipamento.sensores.filter(
        ({ calibravel, calibracao }) =>
          calibravel && calibracao.status === AcaoStatusTipo.Aguardando
      ).length
      if (!shouldClearCalibracaoId) return
      this.calibracaoId = null
    },
  },
  beforeMount() {
    this.setCalibracaoId()
  },
  methods: {
    canEquipamentoEditar: auth.canEquipamentoEditar.bind(auth),
    canCmdAuto: auth.canCmdAuto.bind(auth),
    canCalibracao: auth.canCalibracao.bind(auth),
    async setCalibracaoId() {
      const calibracoesAguardando = (
        await http.get(
          `equipamento/${this.equipamento.id}/acao?status=0&origem=5`
        )
      ).paged.results
      this.calibracaoId = calibracoesAguardando.length
        ? calibracoesAguardando[0].id
        : null
    },
    async cancelCalibracao() {
      await http.put(`equipamento/acao`, {
        acaoId: this.calibracaoId,
      })
    },
    handleEnviarSensor(id) {
      this.sensorEnvioId = id
      this.dialogEnviarSensor = true
    },
    async handleEnvioTodasCalibracoes() {
      this.loading = true
      this.dialogEnviarTodos = false

      this.$nextTick(async () => {
        const result = await http.post(
          `equipamento/calibracao/${this.equipamento.id}/sensores/enviar`
        )
        this.loading = false

        if (result == null) {
          return
        }
        this.calibracaoId = result
      })
    },
    async handleEnvioSensorCalibracao() {
      this.dialogEnviarSensor = false
      this.loading = true

      this.$nextTick(async () => {
        const result = await http.post(
          `equipamento/calibracao/${this.equipamento.id}/sensores/enviar`,
          {
            sensoresIds: [this.sensorEnvioId],
          }
        )
        this.loading = false

        if (result == null) {
          return
        }

        this.$emit('change', this.sensorEnvioId)

        this.sensorEnvioId = null
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
